import pako from "pako";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { decompressjsondata, decrypt } from "../../../../actions/common";
import { AgGridReact } from "ag-grid-react";
import Accordion from "./common/Accordion";
import Loader from "rsuite/esm/Loader";
import NoDataFound from "./common/NoDataFound";
import { isEmpty } from "../../../../utils/utils";

const AppDetailsPanel = ({ customerDetails, appDetails, setAppDetails, ismuvi5 }) => {
  const muvi_one_product_key = "3D28C83C85544F0D9517DD2E7C7EEDAA";

  const serverId = 1;
  const has_local_data = localStorage.getItem("encdata") ? 1 : 0;
  const localdata = has_local_data
    ? decrypt(localStorage.getItem("encdata"), 0)
    : "";
  const userId = has_local_data ? localdata.user_id : "";
  const location = useLocation();

  const [studioId, setStudioId] = useState(null);
  // const [appDetails, setAppDetails] = useState({});
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const hasFetchedRef = useRef(false);

  useEffect(() => {

    if (
      ismuvi5
    ) {
      setStudioId(Number(customerDetails.customer_id));
    }
    if (
      customerDetails &&
      customerDetails.product &&
      customerDetails.product.length > 0
    ) {
      customerDetails.product.forEach((productKey) => {
        if (productKey === muvi_one_product_key && !hasFetchedRef.current) {
          getTemplateDetails();
          hasFetchedRef.current = true;
        }
        else{
          setTemplates([])
        }
      });
    }
  }, [customerDetails, ismuvi5]);

  useEffect(() => {
    if (!studioId) {
      return;
    }
    otherBillingDetails();
    customerDeepLinking();
    // showLoginDetails();
  }, [studioId]);

  const isDebug = () => {
    const searchParams = new URLSearchParams(location.search);
    const queryString = searchParams.get("debug");
    const debug = queryString == null || queryString == "false" ? false : true;
    return debug;
  };

  const getTemplateDetails = () => {
    setTemplates([]);
    if (!customerDetails) {
      return;
    }
    setLoading(true);
    let templatesList = [];
    const debug = isDebug();
    let columnsfetch = {
      app_token: customerDetails.customer_id,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(columnsfetch)
      : pako.gzip(JSON.stringify(columnsfetch));
    fetch(process.env.REACT_APP_CRM + "/muvi6/frontend/get-account-template", {
      method: "POST",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        if (
          findresponse &&
          findresponse.code === 200 &&
          findresponse.data &&
          findresponse.data.template_name
        ) {

          templatesList = [
            {
              template: findresponse.data.template_name,
              platform: "Website",
              domain: customerDetails.domain || "NA",
            },
          ];
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error.message);
      })
      .finally(() => {
        if (templatesList.length > 0) {
          setTemplates(templatesList);
        } else if (templatesList.length == 0 && customerDetails.domain) {
          setTemplates([
            {
              template: "NA",
              platform: "Website",
              domain: customerDetails.domain || "NA",
            },
          ]);
        }

        setLoading(false);
      });
  };

  const otherBillingDetails = () => {
    const debug = isDebug();
    let bodyParams = {
      studio_id: studioId,
      is_live: false,
      // enterprise_api_gateway_url: enterpriseurl,
      server_id: serverId,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi5/other-billing-details", {
      method: "POST",
      dataType: "json",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        setAppDetails({
          package_name: findresponse && findresponse.package_name,
          // bandwidth_log: findresponse && findresponse.bandwidth_log,
          storage: findresponse && findresponse.storage,
          currency: findresponse && findresponse.currency,
          apiKey: findresponse && findresponse.apiKey,
          apiKeyStatus: findresponse && findresponse.apiKeyStatus,
          subadmin_count: findresponse && findresponse.subadmin_count,
          cards_list: findresponse && findresponse.cards_list,
          payment_method: findresponse && findresponse.payment_method,
          revenue_last_month: findresponse && findresponse.revenue_last_month,
          total_no_of_subscribed_users:
            findresponse && findresponse.total_no_of_subscribed_users,
          enduser_count: findresponse && findresponse.enduser_count,
        });
      })
      // .then(() => {
      //   getBandwidthDetails();
      // })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };

  const customerDeepLinking = () => {
    setLoading(true);
    const debug = isDebug();
    let bodyParams = {
      studio_id: studioId,
      user_id: userId,
      is_live: false,
      debug,
    };
    const compressedPostData = debug
      ? JSON.stringify(bodyParams)
      : pako.gzip(JSON.stringify(bodyParams));
    fetch(process.env.REACT_APP_CRM + "/muvi5/customer-deep-linking", {
      method: "POST",
      dataType: "json",
      body: compressedPostData,
    })
      .then((response) => (debug ? response.json() : response.arrayBuffer())) // Get response body as ArrayBuffer
      .then((buffer) => {
        const findresponse = debug ? buffer : decompressjsondata(buffer);
        const androidData = (findresponse && findresponse.android_data) || {};
        const iosData = (findresponse && findresponse.ios_data) || {};
        const rokuData = (findresponse && findresponse.roku_data) || {};
        setAppDetails((prev) => {
          return {
            ...prev,
            android_id: androidData.android_id || "",
            andr_fcm_key: androidData.fcm_key || "",
            andr_deep_link_code: androidData.deep_link_code || "",
            android_config_id: androidData.android_config_id,
            andr_client_id: androidData.client_id,
            andr_client_secret: androidData.client_secret,
            andr_refresh_token: androidData.refresh_token,
            android_version_code_id: androidData.android_version_code_id,

            ios_fcm_key: iosData.fcm_key,
            ios_deep_link_code: iosData.deep_link_code,
            ios_config_id: iosData.ios_config_id,
            ios_secret_code: iosData.secreat_code,
            ios_mode: iosData.ios_mode,
            ios_version_code_id: iosData.ios_version_code_id,
            ios_force_update_version: iosData.version_code,
            roku_config_id: rokuData.roku_config_id,
            roku_sandbox_key: rokuData.sandbox_code,
            roku_production_key: rokuData.production_code,
            roku_mode: rokuData.roku_mode,
            roku_version_code_id: rokuData.roku_version_code_id,
            roku_force_update_version: rokuData.version_code,
            user_permission: findresponse && findresponse.user_permission,
          };
        });

        setLoading(false);
      })
      .catch((error) => {
        console.error("There was a problem with the fetch operation:", error);
      });
  };




  if (!studioId && (!templates || templates.length == 0)) {
    return (
      <div role="tabpanel" class="tab-pane" id="app-details">
        <div style={{ backgroundColor: "white" }}>
          <NoDataFound />
        </div>
      </div>
    );
  }

  return (
    <div role="tabpanel" class="tab-pane" id="app-details">
      <div class="flex-col gap-8">
        <div style={{ backgroundColor: "white" }}>
          {loading && (
            <div className="accordion-component p-8 flex justify-center">
              <Loader content="Loading Content..." />
            </div>
          )}
          {
            !loading &&
            isEmpty(templates) &&
            !studioId && (
              <NoDataFound />
            )
          }
        </div>
        {!loading && templates && templates.length > 0 && (
          <div className="accordion-component p-8">
            <div
              className="ag-theme-alpine"
              style={{
                height: "200px",
                width: "100%",
                padding: "0 6px",
                "--ag-row-group-indent-size": "20px",
                overflowX: "auto",
              }}
              tabIndex={0}
            >
              <AgGridReact
                className="scrollable"
                columnDefs={[
                  {
                    headerName: "Platform",
                    field: "platform",
                    flex: 1,
                    cellRenderer: (params) => {
                      return params.value ? params.value : "NA";
                    },
                  },
                  {
                    headerName: "Template Name",
                    field: "template",
                    flex: 1,
                    cellRenderer: (params) => {
                      return params.value ? params.value : "NA";
                    },
                  },
                  {
                    headerName: "Domain Name",
                    field: "domain",
                    flex: 2,
                    cellRenderer: (params) => {
                      const url = params.value;

                      if (url) {
                        return (
                          <a
                            href={
                              url.startsWith("http://") ||
                                url.startsWith("https://")
                                ? url
                                : "http://" + url
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {params.value}
                          </a>
                        );
                      }
                      return "NA";
                    },
                  },
                ]}
                rowData={templates || []}
                defaultColDef={{
                  resizable: true,
                  sortable: true,
                }}
                rowHeight={40}
                suppressHorizontalScroll={false}
                theme="legacy"
                suppressContextMenu={true}
                enableCellTextSelection={true}
                enableClipboard={true}
                copyHeadersToClipboard={true}
                enableRangeSelection={true}
              />
            </div>
          </div>
        )}
        {!loading && studioId && (
          <React.Fragment>
            <Accordion header="API" targetID="unknownPanel">
              <div class="app-box row">
                <div class="col-md-12">
                  <div class="app-info">
                    <span>API Key</span>
                    <p>{(appDetails && appDetails.apiKey) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>SDK Name</span>
                    <p>{(appDetails && appDetails.package_name) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>S3 Location</span>
                    <p>{(appDetails && appDetails.region_name) || "NA"}</p>
                  </div>
                </div>
              </div>
            </Accordion>
            <Accordion
              header="Android Mobile/Android TV"
              targetID="androiddetailspanel"
            >
              <div class="app-box row">
                <div class="col-md-12">
                  <div class="app-info">
                    <span>FCM Key</span>
                    <p>{(appDetails && appDetails.andr_fcm_key) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="app-info">
                    <span>Deeplink Code</span>
                    <p>
                      {(appDetails && appDetails.andr_deep_link_code) || "NA"}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>In-app Credentials</span>
                    <p>Add Credentials</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Client ID</span>
                    <p>{(appDetails && appDetails.andr_client_id) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Client Secret</span>
                    <p>
                      {(appDetails && appDetails.andr_client_secret) || "NA"}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Refresh Token</span>
                    <p>
                      {(appDetails && appDetails.andr_refresh_token) || "NA"}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Force Update For Version</span>
                    <p>
                      {(appDetails && appDetails.andr_force_update_version) ||
                        "NA"}
                    </p>
                  </div>
                </div>
              </div>
            </Accordion>
            <Accordion header="Roku TV" targetID="rokudetailspanel">
              <div class="app-box row">
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Shared Secret Key</span>
                    <p>Add Credentials</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Sandbox Key</span>
                    <p>{(appDetails && appDetails.roku_sandbox_key) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Production Key</span>
                    <p>
                      {(appDetails && appDetails.roku_production_key) || "NA"}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Mode</span>
                    <p>
                      {appDetails.roku_mode == "sandbox" ? (
                        "Sandbox"
                      ) : appDetails.roku_mode == "production" ? (
                        "Production"
                      ) : (
                        <p>NA</p>
                      )}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Force Update For Version</span>
                    <p>{appDetails && appDetails.roku_force_update_version}</p>
                  </div>
                </div>
              </div>
            </Accordion>
            <Accordion header="iOS Mobile/Apple TV" targetID="iosdetailspanel">
              <div class="app-box row">
                <div class="col-md-12">
                  <div class="app-info">
                    <span>FCM Key</span>
                    <p>{(appDetails && appDetails.ios_fcm_key) || "NA"}</p>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="app-info">
                    <span>Deeplink Code</span>
                    <p>
                      {(appDetails && appDetails.ios_deep_link_code) || "NA"}
                    </p>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Shared Secret Key</span>
                    <p>{(appDetails && appDetails.ios_secret_code) || "NA"}</p>
                  </div>
                </div>
                {/* <div class="col-md-6">
                <div class="app-info">
                  <span>Key</span>
                  <p>TODO:</p>
                </div>
              </div> */}
                <div class="col-md-4">
                  <div class="app-info">
                    <span>Mode</span>
                    <p>
                      {appDetails.ios_mode == "sandbox" ? (
                        "Sandbox"
                      ) : appDetails.ios_mode == "production" ? (
                        "Production"
                      ) : (
                        <p>NA</p>
                      )}
                    </p>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="app-info">
                    <span>Force Update For Version</span>
                    <p>
                      {(appDetails && appDetails.ios_force_update_version) ||
                        "NA"}
                    </p>
                  </div>
                </div>
              </div>
            </Accordion>

          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default AppDetailsPanel;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/AppDetailsPanel.js